import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';
import _ from 'lodash';
import '../css/SystemIntegratorEdit.css';
import ErrorText from '../ErrorText';
// import cities from './cities';
import Loader from './Loader';
import SnackBar from './SnackBar';

//Distributor edit page  component
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
        // background: 'none !important'
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};


const customStylesSuccess = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '70%',
        overflow: 'auto',
        padding: '2%',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};



export default class WhatsNewEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: this.props.activeModal,
            modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
            noOfParams: [],
            Title: this.props.siCurrentData.title,
            PDF: this.props.siCurrentData.pdf,
            Description: this.props.siCurrentData.description,

            errorMessage: [],
            modalIsOpenSuccess: false,
            loader: false,
            disableSave: true,
            snackbarActive: false,
            snackbarMessage: ''

        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalSuccess = this.closeModalSuccess.bind(this);

    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }


    closeModalSuccess() {
        this.setState({
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpenSuccess: false
                }, () => {
                    this.props.closeAllModal()
                })
            }, 500);

        })
    }
    afterOpenModal() {
    }

    closeModal() {
        this.setState({
            modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpen: false
                }, () => {
                    this.props.closeAllModal()
                })
            }, 500);

        })
    }



    componentDidMount() {
        this.fecthAllSI();
        // let cityNew = [];
        // cities.map((e) => {
        //   let newCity = {
        //     "label": `${e.city}, ${e.state}`
        //   }
        //   cityNew.push(newCity);
        // })
        // this.setState({
        //   indianCityWithState: cityNew
        // }, () => console.log(this.state.indianCityWithState))
    }

    fecthAllSI = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/knowledge-bank', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {

                this.setState({
                    siData: data

                })
                console.log(this.state.siData);  // Check Get distributors data
            })
            .catch((err) => {
                console.log(err)

            })
    }

    onEditFinal = () => {
        const tokenStored = `Token ${localStorage.getItem('token')}`;
        const headers = {
            "Authorization": tokenStored,
            'X-CSRFToken': localStorage.getItem('csrftoken'), // CSRF token if required
        };

        const { Title: title, Description: description } = this.state;

        // console.log(pdf  ,   description);

        // Create FormData object
        const formData = new FormData();
        formData.append('title', title);

        formData.append('description', description);

        fetch(`/cloud/whats-new/${this.props.siCurrentData.id}/`, {
            method: "PUT",
            headers, // Don't include 'Content-Type' for FormData
            body: formData, // Use the FormData object
        })
            .then((response) => {
                if (response.status === 403) {
                    // Handle session timeout
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true });
                    window.location.href = '/session-timeout'
                } else {
                    return response.json();
                }
            })
            .then((data) => {
                let rawData = data;
                data = data;
                const index = Object.keys(data)[0];
                console.log(`${index}: ${data[Object.keys(data)[0]]}`);
                const errorLog = `${index}: ${data[Object.keys(data)[0]]}`;

                if (rawData.message !== 'failure') {
                    // Success case
                    this.setState({
                        modalIsOpen: false,
                        loader: false,
                        modalIsOpenSuccess: true,
                    });
                } else {
                    // Failure case
                    this.setState({
                        loader: false,
                        snackbarActive: true,
                        snackbarMessage: errorLog,
                    });
                    console.log('PUT request failed:', this.state.data);
                }
            })
            .catch((err) => {
                console.log(err); // Log the error
            });
    };


    handleChangeInputBox = (name, event) => {
        this.setState({
            [name]: event,
            disableSave: false,

        });
    };

    onEdit = () => {
        console.log('Editing ID:', this.props.siCurrentData.id);
        this.setState({
            showErrorMessage: true,
            loader: true,      // Start loader
            disableSave: true  // Disable save button
        }, () => this.onEditFinal()); // Directly call onEditFinal
    };



    handleFileUpload(event) {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            this.setState({ PDF: file, showErrorMessage: false, disableSave: false, });

        } else {
            this.setState({ PDF: null, showErrorMessage: true });
            alert('Please upload a valid PDF file.');
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.loader ? <Loader /> : null}
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    className={this.state.modalStateAftereOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModal}>
                            <i class="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>Edit What's New</h3>
                    <div className="row">
                        <div className="col-6  mx-0 px-0" >
                            <InputBox
                                inputText={this.state.Title}
                                placeholder="Title"
                                inputBoxName="Title"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                textLength={50}
                                validate={true}
                            />
                        </div>

                        <div className="col-6" >

                            <InputBox
                                inputText={this.state.Description}
                                // error={ErrorText('email', this.state.SiEmail) !== 'No Error' && this.state.showErrorMessage ? true : false}
                                // errorText={ErrorText('email', this.state.SiEmail) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid Distributor Email' : ''}
                                placeholder="Description"
                                inputBoxName="Description"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                textLength={255}
                                blockSpecialChar={false} // ✅ prevent special char input
                            />
                        </div>

                    </div>
                    <div className="float-right" style={{ marginTop: '70px', marginRight: '-15px' }}>
                        <div className="btn btn-new-grey" onClick={this.closeModal} style={{ marginRight: '15px' }} >Cancel</div>
                        <div className="btn btn-new-green" onClick={() => {
                            if (!this.state.disableSave) {
                                this.onEdit()
                            }
                        }
                        }
                            style={{
                                cursor: this.state.disableSave ? 'not-allowed' : '',
                            }}
                        >Save Changes</div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.modalIsOpenSuccess}
                    style={customStylesSuccess}
                    className={this.state.modalStateAftereOpenSuccess}
                    contentLabel="Example Modal">
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModalSuccess}>
                            <i className="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <div className="display-4 text-center">
                        <h3 className="modal-heading thanks-message">What's New edited successfully.</h3>
                        <i class="fas fa-check-circle update"></i>
                        <br />
                        <div className="btn btn-new-grey"
                            onClick={this.closeModalSuccess}>
                            Close
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
